// extracted by mini-css-extract-plugin
export default {"panel":"admin_panel__SXpZD"};